import { Element } from "@xmpp/xml"
import { DeliveryOrder, MessageDisplayType } from "../reducers/messagesSlice"
import MessageParser from "./messageParser"

export default class DeliveryOrderParser {
  static parse(stanza: Element, timestamp?: string): DeliveryOrder | undefined {
    const deliveryOrderElement = stanza.getChild("delivery-order")
    if (!deliveryOrderElement) return

    // Handle multiple files
    const fileUrlElements = deliveryOrderElement.getChildren("file-url")
    const fileNameElements = deliveryOrderElement.getChildren("file-name")

    let fileUrl: string | null = null
    let fileName: string | null = null
    let files: Array<{ fileUrl: string; fileName: string }> | undefined =
      undefined

    if (fileUrlElements.length > 1 || fileNameElements.length > 1) {
      // Multiple files case
      files = []
      const maxLength = Math.max(
        fileUrlElements.length,
        fileNameElements.length,
      )

      for (let i = 0; i < maxLength; i++) {
        const url = fileUrlElements[i]?.getText()
        const name = fileNameElements[i]?.getText()

        if (url && name) {
          files.push({ fileUrl: url, fileName: name })
        }
      }

      if (files.length === 0) return
    } else {
      // Single file case (backward compatibility)
      fileUrl = deliveryOrderElement.getChildText("file-url")
      fileName = deliveryOrderElement.getChildText("file-name")

      if (!fileUrl || !fileName) return
    }

    const metadataElement = deliveryOrderElement.getChild("metadata")
    const jsonElement = metadataElement?.getChild("json", "urn:xmpp:json:0")
    let metadata
    try {
      metadata = jsonElement ? JSON.parse(jsonElement.getText()) : null
    } catch (error) {
      console.error("Error extracting metadata", error)
      metadata = {}
    }
    const deliveryOrderId =
      deliveryOrderElement.getChildText("delivery-order-id") || undefined

    return {
      id: MessageParser.id(stanza, false),
      to: stanza.attrs.to,
      from: stanza.attrs.from,
      messageId: MessageParser.id(stanza, false),
      type: stanza.attrs.type,
      fileUrl,
      fileName,
      files,
      metadata,
      ...(deliveryOrderId ? { deliveryOrderId } : {}),
      timestamp: timestamp || new Date().toISOString(),
      displayType:
        MessageDisplayType.DeliveryOrder as MessageDisplayType.DeliveryOrder,
    }
  }
}
